import useThemeToken from '@/hooks/useTheme';
import { useLocales } from '@/Locales';
import { globalFontSizeAtom, globalFontSizeKeyAtom } from '@/store/theme';
import { getSessionStorage, setSessionStorage } from '@/utils/cookies';
import { Dropdown } from '@sinohealth/butterfly-ui-components';
import React, { useEffect, useState } from 'react';
import { useSetRecoilState } from 'recoil';
import styles from './index.less';

const FONT_SIZE_KEY = 'SYSTEM_FONT_SIZE';

const options = [
  {
    key: 1,
    label: '小号',
    value: 1,
  },
  {
    key: 2,
    label: '中号',
    value: 2,
  },
  {
    key: 3,
    label: '大号',
    value: 3,
  },
];

const FontSize: React.FC<any> = (props) => {
  const themeToken = useThemeToken();
  const { t } = useLocales();
  const [fontSize, setFontSize] = useState(1);
  const setGlobalFontSize = useSetRecoilState(globalFontSizeAtom);
  const setGlobalFontSizeKey = useSetRecoilState(globalFontSizeKeyAtom);

  // 初始化时从 sessionStorage 读取字体设置
  useEffect(() => {
    const savedFontSize = getSessionStorage(FONT_SIZE_KEY);
    if (savedFontSize) {
      const fontSizeKey = savedFontSize.toString();
      applyFontSize(fontSizeKey);
    }
  }, []);

  // 应用字体大小设置
  const applyFontSize = (key: string) => {
    window.document.documentElement.setAttribute('data-size', key);
    setFontSize(+key);
    let size = 14;
    if (key === '1') {
      size = 14;
    } else if (key === '2') {
      size = 14 * 1.1;
    } else if (key === '3') {
      size = 14 * 1.2;
    }
    setGlobalFontSizeKey(key);
    setGlobalFontSize(size);
  };

  const handleSelectFontSize = (e: any) => {
    const fontSizeKey = e.key.toString();
    // 保存到 sessionStorage
    setSessionStorage(FONT_SIZE_KEY, fontSizeKey);
    // 应用字体大小
    applyFontSize(fontSizeKey);
  };

  return (
    <Dropdown menu={{ items: options, onClick: handleSelectFontSize }}>
      <div className={styles.team} style={{ background: themeToken.colorBgBase }}>
        <div className={styles.left} style={{ color: themeToken.colorTextSecondary }}>
          {t('字号')}:
        </div>
        <div className={styles.right}>
          {options.find((item: any) => item.value === fontSize)?.label}
          <span
            className="iconfont icon-arrow-down-s-line"
            style={{ color: themeToken.colorTextSecondary }}
          />
        </div>
      </div>
    </Dropdown>
  );
};

export default FontSize;
